































































































































































/* 共通 */
import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
/* ストア、定数関連 */
import { mailSchedule } from '../store/modules/MailSchedule'; // ストアモジュール
import { supervisingModule } from '../../store/modules/OperationSupervising'; // 画面統括モジュール
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { AuthoritiesId } from '@/CommonUtils/fixed/AuthoritiesId';
import { KanriConstants } from '../fixed/KanriConstants';
import axios from 'axios';
import { loadingControlModule } from '../../store/modules/LoadingControl';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

/**
 * 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add
 */
@Component
export default class MailScheduleInfo extends ApiAccessBase {
  // ユーザ権限の有無
  private isUpdateAuth: boolean = this.checkAuthority(AuthoritiesId.MSS_UPDATE);
  private isCreateAuth: boolean = this.checkAuthority(AuthoritiesId.MSS_CREATE);
  // 拡張パネルの設定（検索条件）
  private exPanel: number[] = [];
  private variableColNames: string[] = [];

  private isUpdate: boolean = false;
  private isContentsUpdate: boolean = false;
  private isRequest: boolean = false;
  private isCancel: boolean = false;
  private isDelete: boolean = false;
  private isDownloadResults: boolean = false;
  private scheduleStatus: string = '';
  private scheduleMessage: string = '';
  private sendCount: string = '';
  private jobStartTime: string = '';
  private jobEndTime: string = '';
  private jobRemarks: string = '';
  private isInitGetStatus: boolean = false;

  private btnRegist: string = '登録';
  private btnRequest: string = '送信指示';
  private btnCancel: string = 'キャンセル';
  private btnMail: string = 'メール内容編集';
  private btnResults: string = '送信結果出力';
  private btnReturn: string = '戻る';

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = 'メール送信スケジュール登録';
    let path = '';
    console.log('GET_DATA_COPY = ' + mailSchedule.GET_DATA_COPY);
    if (mailSchedule.GET_IS_ID_SETTING) {
      if (mailSchedule.GET_DATA_COPY) {
        // 複写（新規登録）
        path = KanriConstants.MAIL_SCHEDULE_PATH + '/init/copy' + mailSchedule.GET_PATH;
      } else {
        // 編集時
        path = KanriConstants.MAIL_SCHEDULE_PATH + mailSchedule.GET_PATH;
        this.isInitGetStatus = true;
      }
    } else {
      // 新規登録時
      path = KanriConstants.MAIL_SCHEDULE_PATH + '/init/info';
    }
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
          // 使用する可変項目の設定（全て）
          this.setAllVariablecolsState();
          let panelIndex = 0;
          if (this.isInitGetStatus) {
            this.getStatus();
            this.exPanel.push(panelIndex);
            panelIndex++;
          } else {
            // this.isUpdate = true;
          }
          if (!supervisingModule.IS_MODE_READ && this.isUpdateAuth) {
            this.backupForm();
          }
          for (const variablecol of Object.keys(this.variablecols)) {
            // パネル設定全オープン
            this.exPanel.push(panelIndex);
            panelIndex++;
            this.variableColNames.push(variablecol);
          }
        }
      },
    );
  }
  /**
   * 「戻る」イベント
   * 遷移元の画面に戻る
   */
  private returnPrevious() {
    if (supervisingModule.IS_MODE_READ) {
      this.back();
    } else {
      // 更新権限があり、formの変更あり
      if (this.isUpdateAuth && !this.isNoChangeFormDataCustom()) {
        if (!window.confirm(Message.I0016)) {
          return;
        }
      }
      // ID設定があり、データ複写ではない
      if (mailSchedule.GET_IS_ID_SETTING && !mailSchedule.GET_DATA_COPY) {
        // 排他削除
        this.apiAccess(KanriConstants.MAIL_SCHEDULE_PATH + mailSchedule.GET_EXCLUSIVE_DELETE_PATH, Constants.API_METHOD_POST, false, null)
        .then((result) => {
          if (result === Constants.API_RESULT_SUCCES) {
            this.back();
          } else {
            this.hrefElement('mailScheduleInfo', -50);
            return;
          }
        });
      } else {
        this.back();
      }
    }
  }
  /**
   * 戻る
   */
  private back() {
    // キー情報削除
    mailSchedule.moduleSelectReset();
    router.push({ name: 'mailScheduleSearch' });
  }
  /**
   * 登録
   */
  private registData() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      const errorBag: any = this.getFormErrorData(this.$refs.form);
      for (const error of Object.keys(errorBag)) {
        if (errorBag[error]) {
          if (!this.focusElement('input-' + error) ) {
            // ラジオボタン用(エラーidのオブジェクトがdivになっておりradioは+1)
            this.focusElement('input-' + (Number(error) + 1));
          }
          break;
        }
      }
      return;
    }
    // 確認
    if (!window.confirm(Message.I0003)) {
      return;
    }
    this.apiAccess(mailSchedule.GET_REGIST_PATH, Constants.API_METHOD_POST, true, false)
    .then((result) => {
      this.hrefElement('mailScheduleInfo', -50);
      if (result === Constants.API_RESULT_SUCCES) {
        // キー情報を設定
        if (!mailSchedule.GET_IS_ID_SETTING || mailSchedule.GET_DATA_COPY) {
          mailSchedule.setScheduleId(this.formData.scheduleId);
          if (mailSchedule.GET_DATA_COPY) {
            // データ複写状態を解除
            mailSchedule.setDataCopy(false);
          }
        }
        this.getStatus();
        if (!this.isInitGetStatus) {
          this.isInitGetStatus = true;
          this.exPanel.push(this.exPanel.length);
        }
        this.backupForm();
      } else {
      }
    });
  }
  /**
   * 業者種別変更
   */
  private traderTypeSwitch(value: string) {
    if (value === '') {
      this.setNendoOptions([]);
      return;
    }
    this.apiAccess(KanriConstants.MAIL_SCHEDULE_PATH + '/nendo/' + value, Constants.API_METHOD_GET, false, true)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        this.setNendoOptions(this.resultData);
      } else {
        this.hrefElement('mailScheduleInfo', -50);
        this.setNendoOptions([]);
      }
    });
  }
  /**
   * リスト設定
   */
  private setNendoOptions(list: any) {
    const obj = this.getVariablecol('mail_schedule_info_params', 'paramsNendo');
    obj.options = list;
    obj.value = '';
    //labelが変動しないとoptionsの変更が反映されない？
    const tempLabel = obj.label;
    obj.label = '';
    obj.label = tempLabel;
  }
  /**
   * メール内容編集
   */
  private mailContent() {
    if (!supervisingModule.IS_MODE_READ && this.isUpdateAuth && !this.isNoChangeFormDataCustom()) {
      if (!window.confirm(Message.I0016)) {
        return;
      }
    }
    router.push({ name: 'mailScheduleContentInfo' });
  }
  /**
   * csvダウンロード
   */
  private csvDownload() {
    // ボタン押下時
    if (window.confirm(Message.I0021)) {
      this.apiAccessDownload(KanriConstants.MAIL_SCHEDULE_PATH + '/result' + mailSchedule.GET_PATH);
    }
  }
  /**
   * スケジュール指示
   */
  private requestSchedule() {
    if (!supervisingModule.IS_MODE_READ && this.isUpdateAuth && !this.isNoChangeFormDataCustom()) {
      alert('入力内容が変更されています。先に登録を行ってください。');
      return;
    }
    this.changeQueue('/update/request');
  }
  /**
   * キャンセル
   */
  private cancelSchedule() {
    this.changeQueue('/update/cancel');
  }
  /**
   * 指示/キャンセル
   */
  private changeQueue(changePath: string) {
    if (!window.confirm(Message.I0003)) {
      return;
    }
    this.hrefElement('mailScheduleInfo', -50);
    this.apiAccess(KanriConstants.MAIL_SCHEDULE_PATH + changePath + mailSchedule.GET_PATH, Constants.API_METHOD_POST, false, false)
    .then((result) => {
      if (result === Constants.API_RESULT_SUCCES) {
        this.backupForm();
        this.getStatus();
      }
    });
  }
  /**
   * 状況取得
   */
  private getStatus() {
    loadingControlModule.startLoading();
    axios.get(KanriConstants.MAIL_SCHEDULE_PATH + '/status' + mailSchedule.GET_PATH)
    .then((response) => {
      this.isUpdate = response.data.update;
      this.isContentsUpdate = response.data.contentsUpdate;
      this.isRequest = response.data.request;
      this.isCancel = response.data.cancel;
      this.isDelete = response.data.delete;
      this.isDownloadResults = response.data.downloadResults;
      this.scheduleStatus = response.data.statusValue;
      this.scheduleMessage = response.data.message;
      this.sendCount = response.data.sendCount;
      this.jobStartTime = response.data.jobStartTime;
      this.jobEndTime = response.data.jobEndTime;
      this.jobRemarks = response.data.remarks;
    }).catch((error) => {
      this.errorMessage += error.response.data.code + ':' + error.response.data.message + '\n';
    }).finally(() => {
      loadingControlModule.endLoading();
    });
  }
  /**
   * form変更有無チェック（カスタム）
   * チェックボックス未入力の値がタイミングによって異なるため標準の判定では実施できない
   */
  private isNoChangeFormDataCustom(): boolean {
    this.createSendForm();
    if (this.isNoCheck(this.bkFormData.paramsChangeTypeDelete)) {
      this.bkFormData.paramsChangeTypeDelete = '';
    }
    if (this.isNoCheck(this.formData.paramsChangeTypeDelete)) {
      this.formData.paramsChangeTypeDelete = '';
    }
    if (this.isNoCheck(this.bkFormData.paramsSendAddAddress)) {
      this.bkFormData.paramsSendAddAddress = '';
    }
    if (this.isNoCheck(this.formData.paramsSendAddAddress)) {
      this.formData.paramsSendAddAddress = '';
    }
    if (this.isNoCheck(this.bkFormData.paramsNewStatus)) {
      this.bkFormData.paramsNewStatus = [];
    }
    if (this.isNoCheck(this.formData.paramsNewStatus)) {
      this.formData.paramsNewStatus = [];
    }
    if (this.isNoCheck(this.bkFormData.paramsChangeStatus)) {
      this.bkFormData.paramsChangeStatus = [];
    }
    if (this.isNoCheck(this.formData.paramsChangeStatus)) {
      this.formData.paramsChangeStatus = [];
    }
    if (JSON.stringify(this.bkFormData) !== JSON.stringify(this.formData)) {
      // console.log('bkFormData');
      // console.log(JSON.stringify(this.bkFormData));
      // console.log('formData');
      // console.log(JSON.stringify(this.formData));
      return false;
    }
    return true;
  }
  private isNoCheck(obj: any): boolean {
    if (!obj || obj === '' || obj.length === 0 ) {
      return true;
    }
    return false;
  }
}
